/** IoT Manager — grow-room rack LEVELS (gateway-local). R-190. */
export const growRoomRackLevelEndpoints = {
  list: '/v1/iot-manager/grow-room-rack-levels',
  one: (id: string) => `/v1/iot-manager/grow-room-rack-levels/${id}`,
} as const;
